import paintImg from '../asset/applications/paints.png'
import AgricultureImg from '../asset/applications/Agriculture.png'
import cablesImg from '../asset/applications/cables.png'
import ConstructionImg from '../asset/applications/Construction.png'
import EnvironmentalImg from '../asset/applications/Environmental Protection.png'
import GlassImg from '../asset/applications/Glass Manufacturing.png'
import paperImg from '../asset/applications/paper.png'

const applications = [
    {
      id: 1,
      name:'Paints, Coatings & Adhesives',
      description: `The pride of ANAB is in the paints industry, where our ultra ne, top grade Ground Calcium Carbonate is used as a ller due to its competitive pricing, ease of availability, and desired physical properties such as high brightness, weather resistance, low oil absorption and dispersibility. We provide the best grades in the global market.
The high-brightness calcium carbonates are often chosen for ceiling paints and other areas requiring high dry hiding.`,
      image: paintImg
    },
    {
      id: 2,
      name:'Paper & Coating Pigments',
      description: `In paper coating applications, calcium carbonate is used to make a brighter sheet. For paper filling applications, calcium carbonate can improve the whiteness of the sheet and reduce costs by replacing expensive fiber and pigments. The chemical properties of calcium carbonate are used to produce non- acidic paper.`,
      image: paperImg
    },
    {
      id: 3,
      name:'Cables & Plastics',
      description: `Ground Calcium Carbonate, the main mineral found in limestone, marble, and chalk is also a popular additive in plastic manufacturing including injection molding, blow molding, and extrusion coating. It also allows polymers to heat and cool faster, resulting in higher productivity, output, and faster conversion for plastics producers.
In addition, the use of GCC in plastics production reduces energy use during the manufacturing process, therefore minimizing the carbon footprint and greenhouse gas impact of finished plastic products.`,
      image: cablesImg
    },
    {
      id: 4,
      name:'Construction',
      description: `In construction, GCC has two major applications in concrete and asphalt. For concrete, GCC promotes self-compacting properties, creating a product with better workability, increased strength and an improved appearance. When mixed with asphalt, it acts as a sand modifier to reduce the resistance of the mixture and provide a consistent material that is easier to work with.`,
      image: ConstructionImg
    },
    {
      id: 5,
      name:'Agriculture',
      description: `Animal / Poultry Feed Livestock Nutrition
GCC is an essential mineral for the growth, development, and production of livestock and domestic animals and plays an important role in maintaining health, particularly when more natural feed is not available. Therefore, farmers look to GCC as a calcium supplement for their animals, both for its high quality and cost effectiveness.`,
      image: AgricultureImg
    },
    {
      id: 6,
      name:'Glass Manufacturing',
      description: `Low-contaminant, economic glass manufacturing
The glass industry uses GCC often because it contains minimal levels of contaminants detrimental to the manufacturing process. In particular, it has a low level of iron (typically < 0.02%) along with a consistent level of magnesium (typically < 1%). The limestone produced by ANAB can therefore have both an attractive economic and environmental benefit to glass producers.`,
      image: GlassImg
    },
    {
      id: 7,
      name:'Environmental Protection',
      description: `The pride of ANAB is in the paints industry, where our ultra ne, top grade Ground Calcium Carbonate is used as a ller due to its competitive pricing, ease of availability, and desired physical properties such as high brightness, weather resistance, low oil absorption and dispersibility. We provide the best grades in the global market.
The high-brightness calcium carbonates are often chosen for ceiling paints and other areas requiring high dry hiding.`,
      image: EnvironmentalImg
    },
];

// Exporting the applications array
export default applications;